<template>
	<drawer
			:title="`ID ${ groupIds.id } details`"
			@updateClose="onClose"
			@updateSave="onSave"
	>
		<template #topButtons>
			<div class="topButtons">
				<tool-tip
						:text="pause ? 'Pause' : 'Unpause'"
						:position="{ bottom: 'bottom' }"
				>
					<v-btn
							icon
							color="green"
							:disabled="!isDelete"
							type="button"
							@click="onPay"
					>
						<svg-sprite width="20" height="20" :icon-id="pause ? 'not_pay' : 'pay'"></svg-sprite>
					</v-btn>
				</tool-tip>
				<tool-tip
						text="Delete payment"
						:position="{ bottom: 'bottom' }"
				>
					<v-btn
							icon
							color="green"
							:disabled="!isDelete"
							type="button"
							@click="onDeletePayment"
					>
						<svg-sprite width="20" height="20" icon-id="deleteItem"></svg-sprite>
					</v-btn>
				</tool-tip>
			</div>
		</template>

		<field
				:class-error="getError('customer_id')"
				margin="0 0 10px 0"
				label="Customer"
				placeholder="Select customer"
				@updateAutocompete="onAutocomplete($event, 'customer_id')"
				:autocompleteValue="customer_id"
				:items="customers"
				:isClearable="false"
				is-autocomplete
				is-required
		></field>
		<field
				:class-error="getError('driver_id')"
				margin="0 0 10px 0"
				label="Driver"
				placeholder="Select driver"
				@updateAutocomplete="onAutocomplete($event, 'driver_id')"
				:autocompleteValue="driver_id"
				item-text="name"
				item-value="driver_id"
				:items="drivers"
				:isClearable="false"
				is-autocomplete
				is-required
		></field>
		<field
				:class-error="getError('truck_id')"
				margin="0 0 10px 0"
				label="Truck #"
				placeholder="Select truck"
				@updateAutocomplete="onAutocomplete($event, 'truck_id')"
				:autocompleteValue="truck_id"
				:items="trucks"
				:isClearable="false"
				is-autocomplete
				is-required
		></field>
		<field
				:class-error="getError('category_id')"
				margin="0 0 10px 0"
				label="Category"
				placeholder="Select category"
				@updateSelect="onAutocomplete($event, 'category_id')"
				:autocompleteValue="category_id"
				item-text="name"
				:items="category"
				:isClearable="false"
				is-select
				is-required
		></field>
		<field
				margin="0 0 10px 0"
				label="Payment type"
				placeholder="Select payment"
				@updateSelect="onAutocomplete($event, 'payment_type_id')"
				:autocompleteValue="payment_type_id"
				:items="payment_type"
				item-text="name"
				:isClearable="false"
				is-select
				is-disabled
		></field>
		<field
				:class-error="getError('amount')"
				margin="0 0 10px 0"
				label="Amount"
				placeholder="Select amount"
				type="number"
				:setInputValue="amount"
				@updateInput="onInput($event, 'amount')"
				is-required
		></field>
		<field
				:class-error="getError('charge_from')"
				margin="0 0 10px 0"
				type="text"
				label="Charge from"
				placeholder="Enter charge from"
				:dateValue="charge_from"
				@updateDate="onDate"
				is-no-title
				is-date
				is-required
		></field>
		<field
				:class-error="getError('charge_every_id')"
				margin="0 0 10px 0"
				label="Сharge every"
				placeholder="Select charge"
				@updateSelect="onAutocomplete($event, 'charge_every_id')"
				:autocompleteValue="charge_every_id"
				item-text="name"
				:items="charge_every"
				:isClearable="false"
				is-select
				is-required
		></field>
		<field
				:class-error="getError('charge_amount')"
				v-if="payment_type_id === 2"
				margin="0 0 10px 0"
				label="Charge amount"
				placeholder="Select charge amount"
				type="number"
				:setInputValue="charge_amount"
				@updateInput="onInput($event, 'charge_amount')"
				is-required
		></field>
		<field
				:class-error="getError('number_payments')"
				margin="0 0 10px 0"
				label="Number of payments"
				placeholder="Select number of payments"
				type="number"
				:setInputValue="number_payments"
				tooltip="0 - unlimited payments"
				tooltipPosition="left"
				@updateInput="onInput($event, 'number_payments')"
				is-required
		></field>
		<field
				margin="0 0 10px"
				padding="10px 10px 0 10px"
				width="100%"
				min-height="64px"
				label="Description"
				placeholder="Enter you comments"
				:setInputValue="description"
				@updateInput="onInput($event, 'description')"
				is-textarea
		></field>
	</drawer>
</template>

<script>
// validations
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import ToolTip from "@/shared/ToolTip/ToolTip.vue";
import Drawer from "@/shared/Drawer/Drawer.vue";

export default {
	name: "DetailsDrawer",
	mixins: [ validationMixin ],
	components: {
		Drawer,
		ToolTip,
	},
	props: {
		isPreload: Boolean,
		isEdit: Boolean,
		isDelete: Boolean,
		editItem: Object,
		groupIds: Object
	},
	data: () => ({
		drawer: true,
		isPopup: true,
		description: '',
		id: null,
		pause: true,
		customer_id: null,
		driver_id: null,
		truck_id: null,
		category_id: null,
		payment_type_id: null,
		payments_id: null,
		amount: '',
		charge_every_id: null,
		charge_from: '',
		charge_amount: '',
		number_payments: '',
		category: [],
		charge_every: [],
		customers: [],
		drivers: [],
		payment_type: [],
		trucks: []
	}),
	validations() {
		const isChargeAmount = this['payment_type_id'] === 1 ? {} : { required };
		return {
			customer_id: { required },
			driver_id: { required },
			truck_id: { required },
			payment_type_id: { required },
			charge_every_id: { required },
			amount: { required },
			charge_from: { required },
			charge_amount: isChargeAmount,
			number_payments: { required },
			category_id: { required }
		};
	},
	methods: {
		...mapActions([ 'setAlert' ]),
		getError(key) {
			return this.$v[key] && this.$v[key].$error;
		},
		onClose() {
			this.$emit('updateDrawerClose');
		},
		onPay() {
			this.pause = !this.pause;
		},
		onDeletePayment() {
			this.$emit('updateDeletePayment');
		},
		countAmount(key, amount = 0, changeAmount = 0, numberPayments = 1) {
			if (this.payment_type_id === 2) {
				if (key === 'amount' || key === 'number_payments' || key === 'payment_type_id') {
					const sum = (amount / numberPayments);
					const isDouble = sum.toString().includes('.');
					this['charge_amount'] = isDouble ? sum.toFixed(2) : sum;
				}

				if (key === 'charge_amount') {
					if (!this['charge_amount']) {
						this['number_payments'] = 1;
						this['charge_amount'] = amount;
						return false;
					}

					if (+this['amount'] >= +this['charge_amount']) {
						const sum = (amount / changeAmount).toString();
						const round = parseInt(sum);
						this['number_payments'] = sum.includes('.') ? round + 1 : round;
					} else {
						this['charge_amount'] = amount;
						this.setAlert({ type: "error", message: "Change amount should be less then amount" });
					}
				}
			}
		},
		onInput({ value }, key) {
			this[key] = value;
			this.$nextTick(() => {
				this.countAmount(key, this['amount'], this['charge_amount'], this['number_payments']);
			});
		},
		onAutocomplete({ value }, key) {
			this[key] = (value?.driver_id || value?.id) ?? value;
			if (key === 'payment_type_id') {
				this.$nextTick(() => this.countAmount(key, this['amount'], this['charge_amount'], this['number_payments']));
			}
		},
		onDate(value, key) {
			this[key] = value;
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					customer_id,
					driver_id,
					truck_id,
					category_id,
					payment_type_id,
					amount,
					charge_from,
					charge_every_id,
					number_payments,
					charge_amount,
					description,
					payments_id,
					pause
				} = this.$data;

				const values = {
					customer_id,
					driver_id,
					truck_id,
					category_id,
					payment_type_id,
					amount,
					charge_from,
					charge_every_id,
					number_payments,
					charge_amount,
					description,
					payments_id,
					pause,
					id: this.groupIds['scheduled_id']
				};

				this.$emit('updateEditSave', values);
			} else {
				this.setAlert({ type: "error", message: "Saving error" });
			}

		},
		getName() {
			return `ID ${ this.groupIds.id } details`;
		},
	},
	mounted() {
		if (this.editItem) {
			const { payment, ...object } = this.editItem;
			for (const objectKey in object) {
				this[objectKey] = object[objectKey];
			}

			if (payment) {
				for (const paymentKey in payment) {
					this[paymentKey] = payment[paymentKey];
				}
			}
		}
	}
};
</script>

<style scoped lang="scss">
.topButtons {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
</style>

